module.exports = __webpack_public_path__ + "img/Artboard 7.2f6df648.png";